// ProductInTheBox.tsx
import { useState, useEffect } from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt, faPlus } from '@fortawesome/free-solid-svg-icons';

interface ProductInBoxProps {
  inbox: string[];
  setInbox: React.Dispatch<React.SetStateAction<string[]>>;
}

const ProductIntheBox = ({ inbox, setInbox }: ProductInBoxProps) => {
  const [errors, setErrors] = useState<string[]>(() => inbox.map(() => ''));

  useEffect(() => {
    setErrors(prev => inbox.map((_, i) => prev[i] ?? ''));
  }, [inbox.length]);

  const validateItem = (i: number, value: string) => {
    setErrors(prev => {
      const copy = [...prev];
      copy[i] = value.trim() ? '' : 'Required';
      return copy;
    });
  };

  const updateItem = (i: number, value: string) => {
    setInbox(prev => {
      const copy = [...prev];
      copy[i] = value;
      return copy;
    });
    validateItem(i, value);
  };

  const addItem = () => setInbox(prev => [...prev, '']);
  const removeItem = (i: number) =>
    setInbox(prev => prev.filter((_, idx) => idx !== i));

  return (
    <>
      {inbox.map((item, i) => (
        <Row key={i} className="g-2 mb-2 align-items-start">
          <Col xs={12} md={10}>
            <Form.Control
              value={item}
              placeholder="Item in box"
              isInvalid={!!errors[i]}
              onChange={e => updateItem(i, e.target.value)}
            />
            <Form.Control.Feedback type="invalid">
              {errors[i]}
            </Form.Control.Feedback>
          </Col>
          <Col xs={12} md={2} className="text-md-end">
            <Button
              variant="outline-danger"
              className="w-100 w-md-auto"
              type="button"
              onClick={() => removeItem(i)}
            >
              <FontAwesomeIcon icon={faTrashAlt} />
            </Button>
          </Col>
        </Row>
      ))}

      <Button variant="outline-primary" type="button" onClick={addItem}>
        <FontAwesomeIcon icon={faPlus} className="me-1" />
        Add Item
      </Button>
    </>
  );
};

export default ProductIntheBox;
